import { Stack, Text } from '@mantine/core'

import {
  formatBogglePlayedDateTime,
  type BogglePlayedDateTimeParts,
} from '~/boggle/ui/formatBogglePlayedDateTime'

const RUN_HISTORY_INVALID: BogglePlayedDateTimeParts = {
  date: 'Run date unavailable',
  time: 'Run time unavailable',
}

/**
 * Run-history date stack: month-day-year on top, localized time underneath.
 */
export function BogglePlayedDateTime({
  align = 'left',
  invalid = RUN_HISTORY_INVALID,
  isoString,
  testIdPrefix,
}: {
  align?: 'center' | 'left' | 'right'
  invalid?: BogglePlayedDateTimeParts
  isoString: string
  testIdPrefix?: string
}) {
  const playedAt = formatBogglePlayedDateTime(isoString, invalid)

  return (
    <Stack gap={0} justify="flex-end">
      <Text
        c="yellow.1"
        data-testid={testIdPrefix ? `${testIdPrefix}-date` : undefined}
        fz={15}
        lh={1.2}
        ta={align}
      >
        {playedAt.date}
      </Text>
      <Text
        c="yellow.2"
        data-testid={testIdPrefix ? `${testIdPrefix}-time` : undefined}
        fz={13}
        lh={1.2}
        opacity={0.8}
        ta={align}
      >
        {playedAt.time}
      </Text>
    </Stack>
  )
}
